import { motion, useInView } from 'framer-motion';
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';

interface Props {
  readonly text: string;
  readonly currentItemIndex: number;
  readonly activeItemIndex: number;
  readonly setActiveItemIndex: Dispatch<SetStateAction<number>>;
}

const VideoWithAnimatedTextItem = ({
  text,
  currentItemIndex,
  activeItemIndex,
  setActiveItemIndex,
}: Props) => {
  const ref = useRef<HTMLLIElement>(null);
  const isInView = useInView(ref, { margin: '-40% 0px -40% 0px', amount: 0 });
  const isActiveItem = currentItemIndex === activeItemIndex;

  useEffect(() => {
    if (isInView) {
      setActiveItemIndex(currentItemIndex);
    }
  }, [isInView, setActiveItemIndex, currentItemIndex]);

  const animationVariants = {
    hidden: {
      opacity: isActiveItem ? 1 : 0,
      y: (() => {
        if (isActiveItem) return '0px';

        return currentItemIndex < activeItemIndex ? '-70px' : '70px';
      })(),
    },
    visible: { opacity: 1, y: '0px' },
  };

  return (
    <motion.li
      ref={ref}
      initial="hidden"
      animate={isActiveItem ? 'visible' : 'hidden'}
      variants={animationVariants}
      transition={{
        damping: 20,
        duration: 0.4,
        mass: 0.2,
        type: 'spring',
      }}
      className="h1 flex w-full items-center justify-center text-center xl:justify-start xl:text-left"
    >
      {text}
    </motion.li>
  );
};

export default VideoWithAnimatedTextItem;
